import createIntersectionObserver from "../utils/createIntersectionObserver";
import sendToPiwik from "../../../tv24/js/analyticsTools/sendToPiwik";
import getDFPBlock from "../utils/getDFPBlock";
import destroyCatfish from "../destroyAdvBlocks/destroyCatfish";
import loadScript from "../../js/scripts/loadScript";
import styleCatfish from "../utils/styleCatfish";

export default function (opt) {
    if(document.getElementById('newsAnnotation') === null){
        return;
    }

    createIntersectionObserver('#newsAnnotation', renderCatFish);

    function renderCatFish() {
        let mobileCatfishPlace = document.getElementById('mobile-banner-zone');
        if (mobileCatfishPlace !== null) {

            destroyCatfish();
            sendToPiwik('render catfish start');

            let catfishId = 'catfish-desktop-' + Math.round(Math.random() * 1000000);
            let catfishWrapper = document.createElement('div');
            catfishWrapper.id = catfishId;
            mobileCatfishPlace.after(catfishWrapper);

            if (window.innerWidth < 640) {
                let siteId = opt.subsiteName === 'lifestyle' ? 1065 : 4;
                let unitId = opt.subsiteName === 'lifestyle' ? 3913 : 95;

                loadScript('https://a4p.adpartner.pro/media?site_id=' + siteId +'&unit_id=' + unitId);
            } else if (window.innerWidth >= 1024) {
                let computeDesktopCatfish = styleCatfish('catfish-desktop-', 970);

                getDFPBlock('/56301415/24tv_desktop_catfish', [[970, 90], [1, 1]], catfishId, '970px', computeDesktopCatfish, undefined);
            }
        }
    }
}